import script from "./MobileTab1.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileTab1.vue?vue&type=script&setup=true&lang=ts"

import "./MobileTab1.vue?vue&type=style&index=0&id=1eb8555e&lang=scss&scoped=true"
import "./MobileTab1.vue?vue&type=style&index=1&id=1eb8555e&lang=scss"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eb8555e"]])

export default __exports__